import { IImageStyles, IStyle } from '@fluentui/react';
import { CommonStyles, FontSizes, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IListCellImageStyles {
  root?: IStyle;
  icon?: IStyle;
}

export interface IListCellImageClassNames {
  root: string;
  icon: string;
}

export const listCellImageStylesDefault = (theme: IH2OTheme): Partial<IListCellImageStyles> => ({
  root: {
    height: '100%',
    marginRight: Sizes.padding,
    ...CommonStyles.flexCenterVertically,
  },
  icon: {
    width: '40px',
    height: '40px',
    borderRadius: Sizes.borderRadius,
    backgroundColor: theme.semanticColors?.buttonPrimaryBackground,
    textAlign: 'center',
    ...CommonStyles.flexCenterVertically,
    i: {
      color: theme.palette?.white,
      fontSize: FontSizes.buttonIcon,
    },
  },
});

export const imageStylesListCellImage = (theme: IH2OTheme): Partial<IImageStyles> => ({
  root: {
    background: theme.palette?.transparent,
    height: '40px',
    width: '40px',
    flexShrink: 0,
    borderRadius: Sizes.borderRadius,
  },
});
